// Module
var code = "<p><a href=\"https://www.pheaa.org/loan-default/faq#id_m-1mooumk_accordion\">WHAT CONSEQUENCES CAN OCCUR AS A RESULT OF NON-PAYMENT?</a></p> ";
// Exports
export default code;